const LAYOUT_STATES = {
  INITIAL: 'initial',
  SUBMITTED: 'submitted'
};

export {
  LAYOUT_STATES
};
